// =====================================
//
//   確認退款 Modal
//   Author: Wayne
//   createtime: 2016 / 03 / 29
//   updatetime: 2016 / 03 / 29
//
// =====================================
// confirm_payment
window.InifECMobileApp.directive('confirmExtrafeePayment', ['$rootScope', '$stateParams', '$state', '$timeout', '$ngModal', 'ExtraFeeService', 'PointService', 'UserService',
    function($rootScope, $stateParams, $state, $timeout, $ngModal, ExtraFeeService, PointService, UserService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 打開 Modal
            // --------------------------------
            var openModal = function() {

                $ngModal.openModal('confirm-extrafee-payment-modal');
            }

            // --------------------------------
            // [private] 關閉 Modal
            // --------------------------------
            var closeModal = function() {

                $ngModal.closeModal('confirm-extrafee-payment-modal');
            }

            // --------------------------------
            // 取消
            // --------------------------------
            var cancel = function() {
                
                closeModal();
            }

            var getExtraFee = function() {
                
                ExtraFeeService.getExtraFee($scope.extrafeeid).then(function(result) {
                    if(result) {
                        $scope.extrafee = result;
                        $scope.orderid = $scope.extrafee.orderid;
                        $scope.paymentmethod = Paytype_SinopacATM;
                        // $scope.paymentmethod = Paytype_OutwardRemittance;

                        if(result.paymentmethod > 0) {
                            $scope.paymentmethod = result.paymentmethod;
                        }
                    }

                    $scope.isLoaded = true;

                }, function(error) {
                    if(error && error.code == 'error.itemIsNotExist') {
                        $scope.isExtrafeeNotExist = true;
                    } else {
                        $scope.isError = true;
                    }
                    
                    $scope.isLoading = false;
                });
            }

            var getMemberPointsBalance = function(){
                
                PointService.getMemberPointsBalance().then(function(result){
                    if(result){
                        $scope.pointsBalanceRec = result;
                        $scope.points = $scope.pointsBalanceRec.pointsbalance;
                        $scope.pointsEnableFlag = $scope.pointsBalanceRec.enableflag;
                        $scope.userpointtype = $scope.pointsBalanceRec.userpointtype;
                    }
                }, function(error){
                    
                });
            };

            // --------------------------------
            // 確認付款
            // --------------------------------
            var confirmPayment = function(){

                if($scope.isPaymentProcessing){
                    return;
                }

                if($scope.paymentmethod == Paytype_Point 
                    && ($scope.points <= 0 || !$scope.pointsEnableFlag || $scope.extrafee.totalamount > $scope.points) 
                ){
                    return;
                }

                if($scope.paymentmethod == Paytype_Monthly 
                    && ($scope.points <= 0 || !$scope.pointsEnableFlag || $scope.extrafee.totalamount > $scope.points) 
                ){
                    return;
                }

                var title = '確定付款嗎？';
                var description;

                if($scope.paymentmethod == Paytype_SinopacATM) {
                    description = '將使用Atm付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_SinopacCreditCard){
                    description = '將使用信用卡付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_Point){
                    description = '將使用預儲點數付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_OutwardRemittance) {
                    description = '將使用臨櫃付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_Spgateway_Cvs) {
                    description = '將使用超商付款，確定嗎？';
                } else if($scope.paymentmethod == Paytype_Monthly) {
                    description = '將使用月結點數付款，確定嗎？';
                }

                $rootScope.$broadcast('OPEN_CONFIRM_MODAL', {
                    title: title,
                    description: description,
                    callback: function(result) {
                        if(result) {
                            $scope.isPaymentProcessing = true;

                            ExtraFeeService.setPayType($scope.extrafeeid, $scope.paymentmethod).then(function(result) {
                                if(result) {
                                    if($scope.paymentmethod == Paytype_SinopacATM) {
                                        $state.go(window.STATES.EXTRAFEE_PAYMENT_SINOPACATM, {extrafeeid: $scope.extrafeeid});
                                    } else if($scope.paymentmethod == Paytype_SinopacCreditCard){
                                        $state.go(window.STATES.EXTRAFEE_PAYMENT_SINOPACCREDITCARD, {extrafeeid: $scope.extrafeeid});
                                    } else if($scope.paymentmethod == Paytype_Point){
                                        $state.go(window.STATES.EXTRAFEE_PAYMENT_POINT, {extrafeeid: $scope.extrafeeid});
                                    } else if($scope.paymentmethod == Paytype_OutwardRemittance) {
                                        $state.go(window.STATES.EXTRAFEE_PAYMENT_OUTWARDREMITTANCE, {extrafeeid: $scope.extrafeeid});
                                    } else if($scope.paymentmethod == Paytype_Spgateway_Cvs) {
                                        $state.go(window.STATES.EXTRAFEE_PAYMENT_SPGATEWAYCVS, {extrafeeid: $scope.extrafeeid});
                                    } else if($scope.paymentmethod == Paytype_Monthly) {
                                        $state.go(window.STATES.EXTRAFEE_PAYMENT_MONTHLY, {extrafeeid: $scope.extrafeeid});
                                    }
                                }

                                $scope.isPaymentProcessing = false;
                                $scope.callback && $scope.callback();
                                closeModal();
                            }, function(error) {
                                if(error && error.code == 'error.itemIsNotExist') {
                                    $scope.isExtrafeeNotExist = true;
                                } else {
                                    $scope.isError = true;
                                }
                                
                                $scope.isPaymentProcessing = false;
                            });
                        }
                    }
                });
            }

            var changePaymentMethod = function(paymentmethod) {

                $scope.paymentmethod = paymentmethod;
            };

            // --------------------------------
            // [private] 初始化
            // --------------------------------
            var getUserInfo = function() {

                UserService.getUserInfo().then(function(result){
                    $scope.user = result;
                });
            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_CONFIRM_EXTRAFEE_PAYMENT_MODAL", function(event, data) {

                if(data) {
                    $scope.extrafeeid = data.extrafeeid;
                    $scope.callback = data.callback;
                    $scope.isLoaded = false;


                    openModal();
                    getUserInfo();
                    getExtraFee();  
                    // getMemberPointsBalance(); 
                }
            });
                
            /*==========================
                Members
            ==========================*/
            $scope.user;
            $scope.extrafeeid;
            $scope.extrafee;
            // $scope.paymentmethod = Paytype_SinopacCreditCard;
            $scope.paymentmethod = Paytype_OutwardRemittance;
            $scope.isLoaded = false;
            $scope.SECURE_INIFEC_URL = SECURE_INIFEC_URL;
            $scope.pointsBalanceRec;
            $scope.points = 0;
            $scope.pointsEnableFlag = true;
            $scope.userpointtype = -1;

            /*==========================
                Methods
            ==========================*/
            $scope.confirmPayment = confirmPayment; // 付款
            $scope.changePaymentMethod = changePaymentMethod;
            $scope.cancel = cancel; // 取消
            $scope.callback;

            /*==========================
                init
            ==========================*/

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'mobile/partials/modal/confirm_extrafee_payment.html';
        _dir.controller = controller;

        return _dir;
}]);